import Column from 'Components/Base/Column'
import Icon from 'Components/Base/Icon'
import Row from 'Components/Base/Row'
import Typography from 'Components/Base/Typography'
import React from 'react'
import { useTheme } from 'styled-components'

interface Props {
  handleFilterOpen: (filterOpen: boolean) => void
  handleSetDropFilter: (dropFilter: number) => void
  dropFilter: number
}

export default function FilterMenu({ handleSetDropFilter, handleFilterOpen, dropFilter }: Props) {
  const theme = useTheme()
  return (
    <Column
      styles={{
        border: '1px solid black',
        position: 'absolute',
        top: 100,
        right: 75,
        backgroundColor: '#fff',
        width: 121,
        height: 156,
        borderRadius: 5,
        textAlign: 'right',
      }}
    >
      <Typography styles={{ marginLeft: 'auto', marginRight: 15, fontWeight: 600 }} color="#4f4f4f" size={13}>
        Filter <Icon name={'filter-list'} styles={{ marginLeft: 5, marginTop: 10 }} color={theme.colors.carePlan.history} />
      </Typography>
      <Row
        styles={{ borderTop: '1px solid black', cursor: 'pointer', backgroundColor: dropFilter === 1 ? '#F2F2F2' : '#fff' }}
        onClick={() => {
          handleFilterOpen(false)
          handleSetDropFilter(1)
        }}
      >
        <Typography styles={{ marginLeft: 'auto', marginRight: 15, paddingTop: 5, paddingBottom: 5 }} color="#4f4f4f" size={13}>
          All
        </Typography>
      </Row>
      <Row
        styles={{ borderTop: '1px solid black', cursor: 'pointer', backgroundColor: dropFilter === 3 ? '#F2F2F2' : '#fff' }}
        onClick={() => {
          handleFilterOpen(false)
          handleSetDropFilter(3)
        }}
      >
        <Typography styles={{ marginLeft: 'auto', marginRight: 15, paddingTop: 5, paddingBottom: 5 }} color="#4f4f4f" size={13}>
          Favorites
        </Typography>
      </Row>
      <Row
        styles={{ borderTop: '1px solid black', cursor: 'pointer', backgroundColor: dropFilter === 2 ? '#F2F2F2' : '#fff' }}
        onClick={() => {
          handleFilterOpen(false)
          handleSetDropFilter(2)
        }}
      >
        <Typography styles={{ marginLeft: 'auto', marginRight: 15, paddingTop: 5, paddingBottom: 5 }} color="#4f4f4f" size={13}>
          Links
        </Typography>
      </Row>

      <Row
        styles={{
          borderTop: '1px solid black',
          cursor: 'pointer',
          backgroundColor: dropFilter === 4 ? '#F2F2F2' : '#fff',
          height: '100%',
          borderBottomLeftRadius: 5,
          borderBottomRightRadius: 5,
        }}
        onClick={() => {
          handleFilterOpen(false)
          handleSetDropFilter(4)
        }}
      >
        <Typography styles={{ marginLeft: 'auto', marginRight: 15, paddingTop: 5 }} color="#4f4f4f" size={13}>
          Documents
        </Typography>
      </Row>
    </Column>
  )
}
